/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 6/25/14
 * Time: 12:03 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var AbstractAppender = require("./AbstractAppender");
    var LEConfig = require("assets/config/le-env-conf");

    var requestPermission =  function () {
        Notification.requestPermission(function (permission) {
            if (!('permission' in Notification)) {
                Notification.permission = permission;
            }
        });
        window.removeEventListener("click", requestPermission);
    };

    var DesktopNotification = AbstractAppender.extend({
        PERMISSION: {
            DEFAULT: "default",
            GRANTED: "granted",
            DENIED: "denied"
        },
        defaultOptions: {
            iconUrl: "/assets/img/LP-logo.png",
            focusStatus: LEConfig.NotificationsDefaults.DesktopNotification.focusStatus
        },

        initialize: function (options) {
            AbstractAppender.prototype.initialize.call(this, options);

            if (!this.isSupported()) {
                return;
            }

            this.setWindowEvents();

            this.notificationCounter = 0;
            this.notifications = {};
        },
        setWindowEvents: function () {
            this.setRequestPermission();
            this.setCloseAllOnUnload();
        },
        isEnabled: function () {
            return true;
        },
        isSupported: function () {
            var isSupported = (!_.isUndefined(window.Notification));
            if (isSupported) {
                isSupported = (this.App.loginInfo && this.App.loginInfo.accountId && this.App.loginInfo.accountId != "new");
            }
            return isSupported;
        },
        getDefaultOptions: function () {
            return _.cloneDeep(this.defaultOptions);
        },
        notify: function (options) {
            this.logger.info("DesktopNotification::notify options: " + JSON.stringify(options));

            if (options.focusStatus && this.App.context.getFocusStatus() <= options.focusStatus) {
                options.iconUrl = options.iconUrl || this.defaultOptions.iconUrl;
                var tag = this.getNotificationTag();

                this.notifications[tag] = new window.Notification(options.title, {
                    icon: options.iconUrl,
                    body: options.body,
                    tag: tag
                });
                this.notifications[tag].onshow = _.bind(this.onNotificationShow,this, options);
                this.notifications[tag].onclose = _.bind(this.onNotificationClose,this, options);
                this.notifications[tag].onclick = _.bind(this.onNotificationClick,this, options);

                return {tag:tag};
            }
        },
        getNotificationTag:function(){
            this.notificationCounter++;

            return this.notificationCounter;
        },

        setRequestPermission: function () {
            if (!Notification.permission || Notification.permission != this.PERMISSION.GRANTED) {
                window.addEventListener("click", requestPermission);
            }
        },
        setCloseAllOnUnload:function(){
            window.addEventListener("unload", this.closeAllNotifications.bind(this));
        },
        isValidOptions: function (options) {
            var isValid = AbstractAppender.prototype.isValidOptions.call(this, options);
            if (isValid) {
                if (!options.title) {
                    this.logger.error("DesktopNotification::isValidOptions - options.title is invalid or missing");
                    isValid = false;
                }
                if (typeof options.body === 'undefined') {
                    this.logger.error("DesktopNotification::isValidOptions - options.body is invalid or missing");
                    isValid = false;
                }
            }
            return isValid;
        },

        openWindow: function (options) {
            if (window.focus) {
                window.focus();
            }
            if (options.persona && this.App.context.get("persona") !== options.persona) {
                this.openPersonaModule(options);
            }
        },
        onNotificationClick :function(options,ev,tag){
            this.openWindow(options);
            if (_.isFunction(options.onClick)) {
                options.onClick(ev.currentTarget.tag);
            }
        },
        onNotificationClose :function(options,ev) {
            if(_.isFunction(options.onClose)){
                options.onClose(ev.currentTarget.tag);
            }
            var notification=ev.currentTarget;
            delete this.notifications[notification.tag];
        },
        onNotificationShow:function(options,ev) {
            var that=this;

            var currentTag = this.currentTag;
            if (currentTag && currentTag != null) {
                setTimeout(function() {
                    that.closeNotification(currentTag);
                }, 5000);
            }
            this.currentTag = ev.currentTarget.tag;

            if (_.isFunction(options.onShow)) {
                options.onShow(ev.currentTarget.tag);
            }
        },

        closeNotification:function(tag){
            if (this.notifications[tag]) {
                this.notifications[tag].close();
            }
        },

        openPersonaModule: function (options) {
            this.App.vent.trigger("onPersonaSwitcher:onSwitch", { switchedPersona: options.persona, backBrowser: false });
        },

        closeAllNotifications:function(){
            for (var key in this.notifications) {
                this.notifications[key].close();
            }
        },
        clearNotification:function(options) {
            this.closeNotification(options.tag);
        },

        isValidClearNotificationOptions:function(options) {
            var isValid = AbstractAppender.prototype.isValidOptions.call(this, options);
            if (isValid) {
                if (!options.tag) {
                    this.logger.error("DesktopNotification::isValidClearNotificationOptions- options.tag is invalid or missing");
                    isValid = false;
                }
            }

            return isValid;
        }

    });

    DesktopNotification.options = [
        "title",
        "body",
        "iconUrl",
        "onClick",
        "onClose",
        "onShow",
        "persona",
        "focusStatus"
    ];

    return DesktopNotification;
});
